var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProsperLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0205 0C35.0242 0 48.0001 12.8968 48.0001 28.8102C48.0001 44.7237 35.0242 57.6261 19.0205 57.6261V38.5875C24.4479 38.5875 28.8475 34.2126 28.8475 28.8099C28.8475 23.4131 24.4479 19.0383 19.0205 19.0383V0Z",
    fill: "#205CC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.021 33.3079C21.4125 33.3079 23.3512 31.3692 23.3512 28.9777C23.3512 26.5861 21.4125 24.6474 19.021 24.6474C16.6294 24.6474 14.6907 26.5861 14.6907 28.9777C14.6907 31.3692 16.6294 33.3079 19.021 33.3079Z",
    fill: "#FF5B2B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.909,
    height: 71.9991,
    fill: "#205CC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsperLogo);
export default __webpack_public_path__ + "static/media/prosper-logo.646c087c7ab42d1c525346ebde1c4e39.svg";
export { ForwardRef as ReactComponent };